import { Box, Button, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { SubscribeProps } from '../interfaces/components';
import { LoccitaneClose } from '../Icons/LoccitaneClose';
import SubscribeImage from '../assets/images/Subscribe.png';
import { SubscribeModal } from '../content';

const Subscribe = ({ activeLocale, active, setActive }: SubscribeProps) => {
  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex="9"
        onClick={() => {
          setActive();
        }}
      />

      <Box
        zIndex="10"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        bg="white"
        padding={['15px', '20px', '25px', '25px']}
        width={['80vw', '350px', '410px', '410px', '450px']}
        height={['400px', '480px', '550px', '550px', '600px']}
      >
        <LoccitaneClose
          boxSize={[6, 6, 8]}
          position="absolute"
          top={['25px', '30px', '35px']}
          right={['25px', '30px', '35px']}
          cursor="pointer"
          fill="black"
          strokeWidth={0.5}
          onClick={() => {
            setActive();
          }}
          zIndex={30}
          stroke="#CCCCCC"
          borderRadius="100%"
          _hover={{ stroke: 'black' }}
          transition=".5s"
        />

        <Box
          border="5px solid #FFCB00"
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="center"
          height="100%"
        >
          <Box
            width={['100%', '100%', '100%', '100%', '100%']}
            display="flex"
            flexDirection={['column', 'column', 'column', 'column', 'column']}
            position="relative"
          >
            <Box
              className="instructions-slider"
              width={['100%', '100%', '100%', '100%', '100%']}
              h={['auto', 'auto', 'auto', 'auto', 'auto']}
              textAlign="center"
            >
              <Image
                width={['100%', '100%', '100%', '100%', '100%']}
                h={['auto', 'auto', 'auto', 'auto', 'auto']}
                objectFit={['contain', 'contain', 'contain', 'contain', 'contain']}
                src={SubscribeImage}
              />
            </Box>
          </Box>
          <Box textAlign="center">
            <Text
              fontSize={['23px', '25px', '30px', '30px', '30px']}
              lineHeight={['23px', '25px', '30px', '30px', '30px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
              fontWeight="500"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof SubscribeModal) in SubscribeModal)
                ? SubscribeModal['en'].textOne
                : SubscribeModal[activeLocale as keyof typeof SubscribeModal].textOne}
            </Text>
            <Text
              fontSize={['23px', '25px', '30px', '30px', '30px']}
              lineHeight={['23px', '25px', '30px', '30px', '30px']}
              fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'LoccitaneRegular'}
              fontWeight="500"
            >
              {activeLocale === undefined || !((activeLocale as keyof typeof SubscribeModal) in SubscribeModal)
                ? SubscribeModal['en'].textTwo
                : SubscribeModal[activeLocale as keyof typeof SubscribeModal].textTwo}
            </Text>
          </Box>

          <Text
            w={['250px', '250px', '250px', '250px', '250px']}
            textAlign="center"
            fontSize={['12px', '13px', '15px', '15px', '15px']}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof SubscribeModal) in SubscribeModal)
              ? SubscribeModal['en'].textThree
              : SubscribeModal[activeLocale as keyof typeof SubscribeModal].textThree}
          </Text>

          <Button
            bg="#FFCB00"
            borderRadius="0px"
            mb={['10px', '20px', '20px']}
            w={['100px', '150px', '200px', '200px', '200px']}
            height={['25px', '35px', '35px', '35px', '35px']}
            fontSize={['12px', '13px', '15px', '15px', '15px']}
            _hover={{ bg: 'rgb(255, 203, 0, 0.4)' }}
            _focus={{ bg: '#FFCB00' }}
            onClick={() => console.log('Sub')}
            fontFamily={activeLocale === 'ar' ? 'GETwoLight' : 'RalewayMedium'}
            textTransform="uppercase"
          >
            {activeLocale === undefined || !((activeLocale as keyof typeof SubscribeModal) in SubscribeModal)
              ? SubscribeModal['en'].button
              : SubscribeModal[activeLocale as keyof typeof SubscribeModal].button}
          </Button>
        </Box>
      </Box>
    </>
  );
};
export default Subscribe;
